export default {
	title: 'Portfolio',
};
